import { BlitsError } from './blits.error';

export class ExternalApiError extends BlitsError {
    public static CODE = "external_api_error";
      
    constructor(message: string) {
        super(ExternalApiError.CODE, message);
    }
}